import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const openHab = defineConnector({
  identifier: "openHab",
  name: "openHAB",
  tagLine: "Open-source home automation platform",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(`${instanceUrl || "http://openhab.local:8080"}/rest`),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the openHAB Main UI, open your user profile and choose “Create new API token”. Give it a name and copy the token — it’s shown only once.",
        },
      ],
    },
    {
      title: "Enter your openHAB details",
      items: [
        {
          kind: "baseUrl",
          label: "openHAB URL",
          placeholder: "http://openhab.local:8080",
          required: true,
          helperText: "The base URL you use to reach the openHAB Main UI.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "http://openhab.local:8080"}/rest/inbox`,
  },
});
